import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronRight, Home, Sprout, Coffee, Microscope, Activity, ShieldCheck, Bug, Wheat, Globe, MapPin, Phone, Mail, ExternalLink, CheckCircle2, ArrowRight } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const agencies = [{
  acronym: 'NAADS',
  name: 'National Agricultural Advisory Services',
  icon: Sprout,
  color: 'bg-green-600',
  borderColor: 'border-green-600',
  established: '2001',
  mandate: 'NAADS was established to increase agricultural production and productivity, improve market access, and promote value addition through demand-driven agricultural advisory services. It serves as the primary vehicle for delivering government agricultural inputs and extension services to farmers across Uganda.',
  functions: ['Distribution of agricultural inputs (seeds, seedlings, livestock) to farmers', 'Coordination of agricultural extension and advisory services', 'Promotion of modern farming technologies and practices', 'Supporting farmer organizations and cooperatives', 'Market linkage facilitation for smallholder farmers'],
  website: 'https://naads.or.ug',
  location: 'Kampala, Uganda',
  phone: '+256 414 345 440',
  email: 'info@naads.or.ug'
}, {
  acronym: 'UCDA',
  name: 'Uganda Coffee Development Authority',
  icon: Coffee,
  color: 'bg-amber-700',
  borderColor: 'border-amber-700',
  established: '1991',
  mandate: 'UCDA promotes and oversees the coffee industry in Uganda to ensure quality and market competitiveness. It regulates the coffee value chain from production to export, positioning Uganda as a leading producer of quality Robusta and Arabica coffee globally.',
  functions: ['Quality control and regulation of coffee exports', 'Coffee research and development coordination', 'Promotion of coffee consumption domestically and internationally', 'Farmer training on good agricultural practices for coffee', 'Coffee value addition and processing support', 'Market intelligence and price monitoring'],
  website: 'https://ugandacoffee.go.ug',
  location: 'Kampala, Uganda',
  phone: '+256 414 256 940',
  email: 'info@ugandacoffee.go.ug'
}, {
  acronym: 'NARO',
  name: 'National Agricultural Research Organisation',
  icon: Microscope,
  color: 'bg-blue-600',
  borderColor: 'border-blue-600',
  established: '2005',
  mandate: 'NARO drives agricultural research and technology development for sustainable farming in Uganda. It coordinates all agricultural research activities in the country through a network of 16 Public Agricultural Research Institutes (PARIs) across different agro-ecological zones.',
  functions: ['Development of improved crop varieties and livestock breeds', 'Soil and water management research', 'Post-harvest technology development', 'Pest and disease management research', 'Climate change adaptation research for agriculture', 'Technology dissemination to farmers through extension partners'],
  website: 'https://www.naro.go.ug',
  location: 'Entebbe, Uganda',
  phone: '+256 414 320 341',
  email: 'dg@naro.go.ug'
}, {
  acronym: 'DDA',
  name: 'Dairy Development Authority',
  icon: Activity,
  color: 'bg-sky-500',
  borderColor: 'border-sky-500',
  established: '1998',
  mandate: 'DDA is responsible for developing and regulating the dairy industry in Uganda. It ensures quality dairy products reach consumers while supporting dairy farmers to improve productivity and profitability across the dairy value chain.',
  functions: ['Regulation and licensing of dairy processors and traders', 'Quality assurance and standards enforcement for dairy products', 'Dairy farmer training and extension services', 'Promotion of dairy consumption and nutrition awareness', 'Coordination of dairy infrastructure development (cooling centers, collection points)', 'Market development and trade facilitation for dairy products'],
  website: 'https://www.dda.or.ug',
  location: 'Kampala, Uganda',
  phone: '+256 414 343 883',
  email: 'info@dda.or.ug'
}, {
  acronym: 'NAGRC&DB',
  name: 'National Animal Genetic Resources Centre & Data Bank',
  icon: ShieldCheck,
  color: 'bg-purple-600',
  borderColor: 'border-purple-600',
  established: '2008',
  mandate: 'NAGRC&DB is responsible for the conservation, management, and sustainable utilization of animal genetic resources in Uganda. It maintains the national gene bank and coordinates breeding programs to improve livestock productivity.',
  functions: ['Conservation of indigenous animal genetic resources', 'Artificial insemination services for livestock improvement', 'Management of national livestock breeding centers and ranches', 'Maintenance of the national animal genetic resources data bank', 'Production and distribution of quality breeding stock', 'Research on animal genetics and breed improvement'],
  website: 'https://www.nagrc.go.ug',
  location: 'Entebbe, Uganda',
  phone: '+256 414 320 832',
  email: 'info@nagrc.go.ug'
}, {
  acronym: 'COCTU',
  name: 'Coordinating Office for Control of Trypanosomiasis in Uganda',
  icon: Bug,
  color: 'bg-red-600',
  borderColor: 'border-red-600',
  established: '1992',
  mandate: 'COCTU coordinates the national effort to control and eradicate trypanosomiasis (sleeping sickness) in both humans and livestock. The disease, transmitted by tsetse flies, affects large parts of Uganda and significantly impacts agricultural productivity.',
  functions: ['Coordination of tsetse and trypanosomiasis control programs', 'Surveillance and monitoring of tsetse fly populations', 'Community sensitization on trypanosomiasis prevention', 'Research coordination on tsetse control methods', 'Distribution of tsetse traps and insecticide-treated targets'],
  website: 'https://www.coctu.go.ug',
  location: 'Kampala, Uganda',
  phone: '+256 414 250 364',
  email: 'info@coctu.go.ug'
}, {
  acronym: 'CDO',
  name: 'Cotton Development Organisation',
  icon: Wheat,
  color: 'bg-emerald-600',
  borderColor: 'border-emerald-600',
  established: '1994',
  mandate: 'CDO promotes and monitors the development of the cotton sub-sector in Uganda. It works to increase cotton production, improve quality, and enhance the competitiveness of Ugandan cotton in regional and international markets.',
  functions: ['Promotion of cotton production among smallholder farmers', 'Quality control and grading of cotton lint', 'Distribution of improved cotton seed varieties', 'Regulation of cotton buying and ginning', 'Market development and export promotion for cotton', 'Farmer training on cotton agronomy and pest management'],
  website: 'https://www.cdouga.org',
  location: 'Kampala, Uganda',
  phone: '+256 414 232 968',
  email: 'info@cdouga.org'
}];
export function AgenciesPage() {
  return <>
      <Header data-id="element-517" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-518">
        {/* Hero */}
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-519">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=1600&h=600&fit=crop")'
        }} data-id="element-520"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-521"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-522">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-523">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-524">
                <Home className="w-4 h-4 mr-1" data-id="element-525" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-526" />
              <span data-id="element-527">Programs & Projects</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-528" />
              <span className="text-white font-medium" data-id="element-529">MAAIF Agencies</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-530">
              MAAIF Agencies
            </h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed" data-id="element-531">
              The Ministry of Agriculture, Animal Industry and Fisheries
              operates through seven semi-autonomous agencies that drive
              agricultural transformation, research, regulation, and development
              across Uganda.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 mt-12" data-id="element-532">
          <div className="space-y-8" data-id="element-533">
            {agencies.map((agency, index) => {
            const Icon = agency.icon;
            return <motion.div key={agency.acronym} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.08
            }} className={`bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden border-l-4 ${agency.borderColor}`} data-id="element-534">
                  <div className="flex flex-col lg:flex-row" data-id="element-535">
                    {/* Left - Key Info */}
                    <div className="lg:w-1/3 bg-gray-50 p-6 md:p-8 border-b lg:border-b-0 lg:border-r border-gray-200" data-id="element-536">
                      <div className="flex items-center gap-4 mb-6" data-id="element-537">
                        <div className={`w-14 h-14 rounded-xl ${agency.color} flex items-center justify-center shadow-sm`} data-id="element-538">
                          <Icon className="w-7 h-7 text-white" data-id="element-539" />
                        </div>
                        <div data-id="element-540">
                          <h2 className="text-2xl font-bold text-uganda-black" data-id="element-541">
                            {agency.acronym}
                          </h2>
                          <p className="text-sm text-gray-500" data-id="element-542">
                            Est. {agency.established}
                          </p>
                        </div>
                      </div>

                      <h3 className="text-lg font-bold text-uganda-black mb-6 leading-snug" data-id="element-543">
                        {agency.name}
                      </h3>

                      <div className="space-y-3 text-sm" data-id="element-544">
                        <div className="flex items-start gap-3" data-id="element-545">
                          <MapPin className="w-4 h-4 text-gray-400 mt-0.5" data-id="element-546" />
                          <span className="text-gray-600" data-id="element-547">
                            {agency.location}
                          </span>
                        </div>
                        <div className="flex items-start gap-3" data-id="element-548">
                          <Phone className="w-4 h-4 text-gray-400 mt-0.5" data-id="element-549" />
                          <span className="text-gray-600" data-id="element-550">{agency.phone}</span>
                        </div>
                        <div className="flex items-start gap-3" data-id="element-551">
                          <Mail className="w-4 h-4 text-gray-400 mt-0.5" data-id="element-552" />
                          <span className="text-gray-600" data-id="element-553">{agency.email}</span>
                        </div>
                        <a href={agency.website} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-uganda-green font-semibold hover:text-green-800 transition-colors mt-2" data-id="element-554">
                          <Globe className="w-4 h-4" data-id="element-555" /> Visit Website
                          <ExternalLink className="w-3 h-3" data-id="element-556" />
                        </a>
                      </div>
                    </div>

                    {/* Right - Details */}
                    <div className="lg:w-2/3 p-6 md:p-8" data-id="element-557">
                      <h3 className="text-lg font-bold text-uganda-black mb-3" data-id="element-558">
                        Mandate
                      </h3>
                      <p className="text-gray-600 leading-relaxed mb-8" data-id="element-559">
                        {agency.mandate}
                      </p>

                      <h3 className="text-lg font-bold text-uganda-black mb-4" data-id="element-560">
                        Key Functions
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-561">
                        {agency.functions.map((func, i) => <div key={i} className="flex items-start gap-3" data-id="element-562">
                            <CheckCircle2 className="w-5 h-5 text-uganda-green flex-shrink-0 mt-0.5" data-id="element-563" />
                            <p className="text-sm text-gray-700 leading-relaxed" data-id="element-564">
                              {func}
                            </p>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </main>
      <Footer data-id="element-565" />
    </>;
}